import { ref, watch } from 'vue';
import { ComputedRef, Ref, IProduct } from '../types/sortable-grid.definitions'; // eslint-disable-line no-unused-vars

const enableLazyForEagerLoaded = ref(false);

/**
 *
 * @param {ComputedRef<{product: IProduct}[]>} items
 * @returns {{enableLazyForEagerLoaded: Ref<boolean>}}
 */
export default function useLazyForEagerLoaded(items) {
  watch(items, () => {
    enableLazyForEagerLoaded.value = true;
  }, { once: true });

  return { enableLazyForEagerLoaded };
}
